import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogTitle,
  Paper,
} from "@mui/material";
import { Stack } from "@mui/system";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PairCurrencyMismatchTable from "./PairCurrencyMismatchTable";

interface PairCurrencyMismatchProps {
  open: boolean;
  handleClose: () => void;
  rows: any[];
  onContinue: () => void;
}

const tableHeadings = {
  company: "Company",
  receipt_number: "Receipt Number",
  receipt_amount: "Receipt Amount",
  fme: "FME",
  debit: "Debit",
  covered: "% Covered",
  fme_status: "Receipt Status",
};

const PairCurrencyMismatch = ({
  open,
  handleClose,
  rows,
  onContinue,
}: PairCurrencyMismatchProps) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { width: "1000px", maxWidth: "1000px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            Currency Mismatch
          </DialogTitle>

          <Alert
            severity="warning"
            icon={
              <ErrorOutlineIcon
                sx={{ color: "rgba(237, 108, 2, 1)" }}
                fontSize="inherit"
              />
            }
            sx={{
              border: "1px solid rgba(237, 108, 2, 0.5)",
              color: "rgba(237, 108, 2, 1)",
              alignItems: "center",
            }}
          >
            <AlertTitle>
              You have selected receipts and FMEs in different Currencies.
            </AlertTitle>
            Please review your selection
          </Alert>

          <PairCurrencyMismatchTable
            tableHeadings={tableHeadings}
            rows={rows}
          />

          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button color="secondary" variant="outlined" onClick={handleClose}>
              CANCEL
            </Button>
            <Button
              sx={{ ml: 2 }}
              color="secondary"
              variant="contained"
              onClick={onContinue}
              data-tracker="592"
            >
              Continue Anyway
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
};

export default PairCurrencyMismatch;
